import {
  SET_SHOW_BACKBTN,
  SET_SHOW_SIDEBAR,
  TOGGLE_SHOW_SIDEBAR,
  RESET_VIEW
} from "../actions/view.actions";

const initialState = {
  showSidebar: true,
  showBackBtn: false,
  pageName: "",
  clientMode: null,
};

export default function viewReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SHOW_SIDEBAR:
      return { ...state, showSidebar: action.payload.showSidebar };
    case TOGGLE_SHOW_SIDEBAR:
      return { ...state, showSidebar: !state.showSidebar };
    case SET_SHOW_BACKBTN:
      return {
        ...state,
        showBackBtn: action.payload.showBackBtn,
        pageName: action.payload.pageName,
      };
    case RESET_VIEW:
      return initialState;
    default:
      return state;
  }
}
